module.exports = __webpack_public_path__ + "img/DownLoad.039d6b32.png";